import { Autocomplete, Box, Stack, TextField, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import { EmployeeMobileDTO, MobileBuildingDTO, MobileBuildingsVovClient } from '../../../ApiOld/Api/ApiServerVov';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { VovClient } from '../../../ApiOld/ApiServerVov';
import { Star } from '@mui/icons-material';

export interface IEmployeeListProps {
    buildingId: number;
    selectedEmployeeId?: number;
    isMandatory?: boolean;
    onEmployeeClick: (employee: EmployeeMobileDTO | undefined) => void;
}

export default function EmployeeList(props: IEmployeeListProps) {
    const { buildingId, selectedEmployeeId, isMandatory, onEmployeeClick } = props;
    const { authorizedMobileEmployeeApi } = useMobileApi(VovClient);
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [employees, setEmployees] = useState<EmployeeMobileDTO[] | undefined>();
    const [selectedEmployee, setSelectedEmployee] = useState<EmployeeMobileDTO | undefined>();
    const [loaded, setLoaded] = useState(false);

    const theme = useTheme();

    useEffect(() => {
        authorizedMobileEmployeeApi.getAllEmployees(buildingId).then((response) => {
            if (response) {
                setEmployees(response.employees);
                setLoaded(true);
            } else {
                setLoaded(true);
            }
        }).catch(() => {
            setLoaded(true);
        });
    }, [authorizedMobileEmployeeApi, enqueueSnackbar, buildingId]);

    useEffect(() => {
        console.log(selectedEmployeeId, employees);
        if (selectedEmployee) {
            setSelectedEmployee(employees?.find(e => e.adminId === selectedEmployeeId));
        }
    }, [selectedEmployeeId, employees]);

    return (
        <Box sx={{ m: 0 }}>
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                size="small"
                onChange={(e, v) => {
                    setSelectedEmployee(v ?? undefined);
                    onEmployeeClick(v ?? undefined);
                }}
                getOptionLabel={o => o !== null && o !== undefined ? o.name ?? "" : ""}
                value={selectedEmployee ?? null}
                options={employees ?? []}
                sx={{ minWidt: '250px' }}
                fullWidth
                renderOption={(props, option) => (
                    <li {...props} key={option.name ?? '' + option.adminId}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Star color="primary" />
                            <span>{option.name}</span>
                        </Stack>
                    </li>
                )}
                renderInput={(params) => <TextField error={isMandatory === true && selectedEmployee === null}  {...params} label={t('todo.responsibleUser') + (isMandatory ? '*' : '')}
                    sx={{ minWidth: '200px' }}
                />}
            />
            {selectedEmployee === null && isMandatory && <p style={{ marginBottom: '0px', marginLeft: '-10px', marginTop: '4px', color: theme.palette.error.main }}>{t('FieldRequired')}</p>}

        </Box>
    );
}
